// Version : 1.0.0
// Author : AGALYA

const OfficialDetailsActionType = {
	/** ***************** Official Details Add Start ************************/
	OFFICIAL_DETAILS_ADD_START: 'official_details_add_start',
	OFFICIAL_DETAILS_ADD_SUCCESS: 'official_details_add_success',
	OFFICIAL_DETAILS_ADD_FAILURE: 'official_details_add_failure',
	OFFICIAL_DETAILS_ADD_RESPONSE_REST_START: 'official_details_add_response_reset_start',
	OFFICIAL_DETAILS_ADD_RESPONSE_CHANGED: 'official_details_add_response_changed',
	/** ***************** Official Details Add End ************************/

	/** ***************** Economic Activity List Start ************************/
	ECONOMIC_ACTIVITY_LIST_START: 'economic_activity_list_start',
	ECONOMIC_ACTIVITY_LIST_SUCCESS: 'economic_activity_list_success',
	ECONOMIC_ACTIVITY_LIST_FAILURE: 'economic_activity_list_failure',
	ECONOMIC_ACTIVITY_LIST_RESPONSE_REST_START: 'economic_activity_list_response_reset_start',
	ECONOMIC_ACTIVITY_LIST_RESPONSE_CHANGED: 'economic_activity_list_response_changed',
	/** ***************** Economic Activity List End ************************/
};

export default OfficialDetailsActionType;
